import * as React from "react"

const RadioGroup = React.forwardRef(({ className, value, onValueChange, children, ...props }, ref) => {
  const handleChange = (newValue) => {
    if (onValueChange && typeof onValueChange === 'function') {
      onValueChange(newValue);
    }
  };

  return (
    <div ref={ref} className={className} role="radiogroup" {...props}>
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            currentValue: value,
            onValueChange: handleChange,
          });
        }
        return child;
      })}
    </div>
  )
})
RadioGroup.displayName = "RadioGroup"

const RadioGroupItem = React.forwardRef(({ className, value, currentValue, onValueChange, ...props }, ref) => {
  const isChecked = value === currentValue;
  
  const handleChange = () => {
    if (onValueChange && typeof onValueChange === 'function') {
      onValueChange(value);
    }
  };

  return (
    <input
      ref={ref}
      type="radio"
      checked={isChecked}
      onChange={handleChange}
      value={value}
      className={`h-4 w-4 border-2 border-gray-400 text-sky-600 focus:ring-2 focus:ring-sky-500 focus:ring-offset-0 cursor-pointer accent-sky-600 ${className || ''}`}
      {...props}
    />
  )
})
RadioGroupItem.displayName = "RadioGroupItem"

export { RadioGroup, RadioGroupItem }
